
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CDSMask } from '@app/utils/cds-mask';

import { MinhaAgenda } from '@app/models/minha-agenda';
import { ProcessoService } from '@app/services/processo.service';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoResumo } from '../../../../../models/processo.model';

@Component({
  selector: 'app-audiencia-form',
  templateUrl: './audiencia-form.component.html'
})
export class AudienciaFormComponent implements OnInit {

  aguardandoSolicitacao = false;
  minhaAgenda: MinhaAgenda = new MinhaAgenda();
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  titulo: string;

  lstUsuarios: IdDescricao[];
  processoResumo: ProcessoResumo;
  descricaoAuto: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private consultasService: ConsultasService

  ) {
    this.minhaAgenda.UsuarioId = null;
  }

  ngOnInit() {

    this.route.parent.params.subscribe(params => {
      this.minhaAgenda.ProcessoId = params['id'];
    });

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar audiência' : 'Nova audiência';

      if (!id) {
        return;
      }

      this.processoService.obterAudienciaPorId(id)
        .subscribe(
          data => this.minhaAgenda = data,
          () => this.router.navigate(['/processos/processo', this.minhaAgenda.ProcessoId, 'audiencia']));
    });

    this.consultasService.consultar('USUARIO').toPromise().then(data => this.lstUsuarios = data);

  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.processoService.gravarAudiencia(this.minhaAgenda)
      .toPromise().then(
        () => this.router.navigate(['/processos/processo', this.minhaAgenda.ProcessoId, 'audiencia']),
        (data) => {
          if (data.error) {
            this.lstErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        }
      );
  }

  populaProcessoResumo(evento) {
    if (!this.minhaAgenda.Descricao) {
      this.descricaoAuto = `${evento.ClienteNome} (${evento.Ficha ?? 'S/Nº Ficha'}) X ${evento.ParteContraria}`;
      this.minhaAgenda.Descricao = this.descricaoAuto;
    }
  }

}
